import { Type, type Static } from "@sinclair/typebox";
import { MatrixRoomIdSchema } from "./identifiers.ts";

export const THREAD_TITLE_SCHEMA_VERSION = "1.0" as const;

const MatrixEventIdSchema = Type.String({
  minLength: 4,
  maxLength: 512,
  pattern: "^\\$[^\\s]+$"
});

export const ThreadTitleTextSchema = Type.String({
  minLength: 1,
  maxLength: 80,
  pattern: "^[^\\r\\n]+$"
});

export const ThreadTitleSummaryInputSchema = Type.Object(
  {
    roomId: MatrixRoomIdSchema,
    threadRootEventId: MatrixEventIdSchema,
    message: Type.String({ minLength: 1, maxLength: 20_000 })
  },
  { additionalProperties: false }
);

export const ThreadTitleSchema = Type.Object(
  {
    version: Type.Literal(THREAD_TITLE_SCHEMA_VERSION),
    title: ThreadTitleTextSchema
  },
  { additionalProperties: false }
);

export const ThreadTitleProjectionSchema = Type.Object(
  {
    version: Type.Literal(THREAD_TITLE_SCHEMA_VERSION),
    threadRootEventId: MatrixEventIdSchema,
    title: ThreadTitleTextSchema,
    updatedAt: Type.String({
      minLength: 20,
      maxLength: 35,
      pattern: "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(?:\\.\\d+)?Z$"
    })
  },
  { additionalProperties: false }
);

export const ThreadTitleQuerySchema = Type.Object(
  {
    threadRootEventIds: Type.Array(MatrixEventIdSchema, {
      minItems: 1,
      maxItems: 500,
      uniqueItems: true
    })
  },
  { additionalProperties: false }
);

export const ThreadTitleQueryResultSchema = Type.Object(
  {
    version: Type.Literal(THREAD_TITLE_SCHEMA_VERSION),
    titles: Type.Array(ThreadTitleProjectionSchema, { maxItems: 500 })
  },
  { additionalProperties: false }
);

export type ThreadTitleSummaryInputV1 = Static<typeof ThreadTitleSummaryInputSchema>;
export type ThreadTitleV1 = Static<typeof ThreadTitleSchema>;
export type ThreadTitleProjectionV1 = Static<typeof ThreadTitleProjectionSchema>;
export type ThreadTitleQueryV1 = Static<typeof ThreadTitleQuerySchema>;
export type ThreadTitleQueryResultV1 = Static<typeof ThreadTitleQueryResultSchema>;
